import { getCookie } from 'cookies-next';

import { COOKIES } from '@/shared/constants/cookies';

const cookieTemporaryDisableCookies = getCookie(
  COOKIES.TEMPORARY_DISABLE_COOKIES
);
export const userAllowsMarketingCookies =
  cookieTemporaryDisableCookies === 'false';
